import React from 'react';

const ActionButtons = ({
    isEditing,
    isSaving,
    onSave,
    thought,
    styles,
    isMobile
}) => {
    const buttonStyles = isMobile ? styles.composePage.mobile : styles.composePage.desktop;
    const isDisabled = !thought.trim() || isSaving;

    return (
        <>
            {!isEditing && (
                <button 
                    onClick={() => onSave(true)}
                    disabled={isDisabled}
                    style={{
                        ...(isMobile ? buttonStyles.addButton : buttonStyles.addButton),
                        ...styles.composePage.shared.button(!isDisabled)
                    }}
                >
                    Add another
                </button>
            )}
            <button 
                onClick={() => onSave(false)}
                disabled={isDisabled}
                style={{
                    ...(isMobile ? buttonStyles.saveButton : buttonStyles.saveButton),
                    ...styles.composePage.shared.button(!isDisabled)
                }}
            >
                {isSaving ? 'Saving...' : isEditing ? 'Update' : 'Save'}
            </button>
        </>
    );
};

export default ActionButtons; 